import React,{useEffect} from 'react'
import './index.scss'
const Carefree = () => {
    useEffect( () => {
        document.title = '《无忧跑单，保驾护航！——承运人责任险保障及服务全面启动》'
        return () => {
            document.title = ''
        }
    } ,[])
    return (
        <div className="carefree_box">
            <h2>亲爱的900出行司机师傅：</h2>
            <p>
                为让您无忧跑单，2021年9月01日起900出行平台为每一位司机的每一个订单承保了承运人责任险，您将获得承运人责任险保障及进保服务保障：
            </p>
            <h3>一、道路客运承运人责任保险保障内容</h3>
            <p>
            险种名称：道路客运承运人责任保险（2020版）</p>
            <p>
            附加险：道路客运承运人责任保险附加司乘人员责任保险 </p>
            <p>保险期限：自乘客上车订单行程时间开始至乘客下车行程时间结束止
            </p>
            <ul>
                <li>
                    <span>保障内容： </span>
                    <em>保障金额（元）</em>
                </li>
                <li>
                    <span>1.每订单每座赔偿限额  </span>
                    <em>100万</em>
                </li>
                <li>
                    <span>2.每订单每座司机猝死赔偿限额  </span>
                    <em>20万</em>
                </li>
                <li>
                    <span>3.每订单每座医疗费用赔偿限额 </span>
                    <em> 10万</em>
                </li>
                <li>
                    <span>4.每订单每座护理费用赔偿标准</span>
                    <em> 按实际赔偿</em>
                </li>
                <li>
                    <span>5.每订单每座误工费赔偿限额</span>
                    <em>按实际赔偿</em>
                </li>
                <li>
                    <span>6.每订单毎座法律费用赔偿限额</span>
                    <em>1万</em>
                </li>
                <li>
                    <span>7.每订单每座残疾用具赔偿限额</span>
                    <em>按实际赔偿</em>
                </li>
                <li>
                    <span>8.每订单每座丧葬费用赔偿限额</span>
                    <em>按所在地上一年度职工月平均工资标准*6个月赔偿</em>
                </li>
                <li>
                    <span> 9.每订单每座乘客财产损失赔偿限额 </span>
                    <em>5万</em>
                </li>
                <li>
                    <span>10.每订单每座住院伙食补赔偿标准</span>
                    <em>住院伙食补助100元/天,营养费50/天</em>
                </li>
                <li>
                    <span> 11.每订单每座救护车费用赔偿限额</span>
                    <em>救护车费用实际为准</em>
                </li>
            </ul>       
            <h3> 二、承运人责任险进保流程及保障</h3>              
            <p>
            第一步：在订单进行过程中，如发生交通事故，拨打报案电话95519报案，</p>
            <p>第二步：报案后，保险公司将有专业安全员和理赔查勘人员进行勘察、核算、理赔、给付，保险责任终止。</p>              
            <h5>特别注意：出后险必须在24小时内报案</h5>     
            <p>让每一位司机的每一个订单都有承运人责任险保障！</p>
            <p>无忧跑单，保驾护航！900出行，与美好同行！</p>          
                              
            <h6>2021年09月01日</h6>
            
        </div>
    )
}
export default Carefree
